import React from "react";
import styles from "./Experience.module.css";

import { FaCalendar } from "react-icons/fa";
import { FaMapPin } from "react-icons/fa";

import FmeLogo from "../../../../../Assets/Images/Logos/fme.png"
import SothapiaLogo from "../../../../../Assets/Images/Logos/Sothapia.png"
import IPBLogo from "../../../../../Assets/Images/Logos/IPB.jpg"

const ExperienceEntries = [
    {
        firm: "Sothapia", 
        logo: SothapiaLogo,
        title: "Collaborator", 
        date: "04/2024 - 08/2025", 
        location: "Cluj-Napoca, Romania",
        content: [
            {
                type: "text", 
                content: "Led development of modular IoT systems for industrial monitoring, enabling clients to track sensor data and automate reports via a mobile app."
            }, 
            {
                type: "list", 
                content: [
                    "Built secure ESP32-based sensors with encrypted storage and OTA updates.",
                    "Developed full software stack: MQTT backend, API, and React Native app.",
                    "Designed scalable, modular infrastructure for rapid feature expansion.",
                    "Supported deployments in refrigeration, transport, and industrial sectors."
                ]
            }
        ],
        learnt: "End-to-end product design, project estimation, and client-focused development.",
        technologies: ["C++", "Python", "Flask", "React Native", "Expo", "TypeScript", "React", "Vite", "MongoDB", "Redis", "Nginx", "Git", "CI/CD", "Ansible", "Docker", "Gunicorn", "fail2ban"]
    },
    {
        firm: "Institut de Physique Biologique", 
        logo: IPBLogo,
        title: "Internship", 
        date: "07/2024 - 10/2024", 
        location: "Strasbourg, France",
        content: [
            {
                type: "text", 
                content: "Built a unified web platform for MRI image analysis, merging multiple desktop viewers into a single modern interface."
            }, 
            {
                type: "list", 
                content: [
                    "Designed a tab-based system for seamless navigation between anatomical, functional, and connectome views.",
                    "Ported full desktop functionality to the web, including overlays, colormaps, and advanced visualization controls.",
                    "Added real-time collaborative sessions and a custom metadata viewer.",
                    "Extended the Niivue WebGL library and built a modular, easily extensible architecture.",
                ]
            }
        ],
        learnt: "Academic research collaboration and open-source library development.",
        technologies: ["TypeScript", "React", "WebGL", "Redis", "Python", "Flask", "Docker", "Git"]
    },
    {
        firm: "fme Romania", 
        logo: FmeLogo,
        title: "Internship", 
        date: "07/2023 - 10/2023", 
        location: "Cluj-Napoca, Romania",
        content: [
            {
                type: "text", 
                content: "Developed a Microsoft Teams extension to display dynamically generated reports based on YAML-defined SQL queries. The backend periodically executed the queries, formatted the results, and provided data for the extension to render as charts, tables, or text according to the YAML report definitions."
            }
        ],
        learnt: "Agile/Scrum methodologies, To quickly adapt to unfamiliar tech stacks.",
        technologies: ["TypeScript", "React", "FluentUI", "SwaggerUI", "PostgreSQL", "pgAdmin", "Prisma", "NestJS", "Firestore", "JWT" , "AuthGuard", "Docker", "Azure Active Directory", "Git", "Jest", "GitLab CI/CD", "A.W.S"]
    },
]

const Experience = ({  }) => {
    return (
        <div className={styles.container}>
            <div className={styles.timeline}>
                {ExperienceEntries.map((entry) => (
                    <div key={`${entry.firm}-${entry.date}`} className={styles.entry}>
                        <div className={styles.entryHeader}>
                            <img src={entry.logo} alt={`${entry.firm} logo`} className={styles.logo} />
                            <div className={styles.headerTexts}>
                                <div className={styles.headerTopRow}>
                                    <p className={styles.firm}>{entry.firm}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.date}>{entry.date}</p>
                                        <FaCalendar className = {styles.icon} />
                                    </div>
                                </div>
                                <div className={styles.headerBottomRow}>
                                    <p className={styles.title}>{entry.title}</p>
                                    <div className={styles.textAndIconContainer}>
                                        <p className={styles.location}>{entry.location}</p>
                                        <FaMapPin className = {styles.icon} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={styles.content}>
                            {entry.content.map((section, idx) => {
                                if (section.type === "text") {
                                    return (
                                        <p key={idx} className={styles.paragraph}>{section.content}</p>
                                    );
                                }
                                if (section.type === "list") {
                                    return (
                                        <ul key={idx} className={styles.list}>
                                            {section.content.map((item, i) => (
                                                <li key={i} className={styles.listItem}>{item}</li>
                                            ))}
                                        </ul>
                                    );
                                }
                                return null;
                            })}
                        </div>

                        {entry.learnt && (
                            <div className={styles.learnt}>
                                <span className={styles.learntLabel}>Learnt:</span>
                                <span className={styles.learntText}>{entry.learnt}</span>
                            </div>
                        )}

                        {!!entry.technologies?.length && (
                            <div className={styles.techList}>
                                {entry.technologies.map((tech) => (
                                    <span key={tech} className={styles.techPill}>{tech}</span>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Experience;